import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import notify from 'devextreme/ui/notify';
import './assets/css/dx.custom.css';
import './assets/css/tailwind.css';
import './workers/registerServiceWorker';
import toastService from "./toastService";
import { applyBranding } from "@/config/branding";

require('@/assets/css/all.min.css')
require('@/assets/css/lineicons.css')
require('@/assets/css/styles.css')

applyBranding();

const app = createApp(App)
app.use(router)
app.use(toastService)
app.mount('#app')

app.config.globalProperties.$pagination = {  
    handleScroll(page, totalPages, dataMounted, callback){
        var elem = document.getElementById("scrollerDiv")
        console.log(elem.scrollY +' + '+ elem.innerHeight +'>='+ document.body.scrollHeight)
        if(elem.scrollY + elem.innerHeight >= document.body.scrollHeight - 50 && page <= totalPages && dataMounted == true){
            page = page + 1;         
            callback();
        } 
    }
}
app.config.globalProperties.$filters = {  
    roundNumber(value, decimals){
        if(value!=null){
            var fltval = parseFloat(value);
            return fltval.toFixed(decimals)
        }
    },
    upperCase(value){
        if(value!=null){
            var strval = String(value);
            return strval.toUpperCase();
        }
    },
    dateFormat(value) {
        if(value!=null){
            value = value.substring(0,10);
            const ArStr = value.split('-')
            value = ArStr[2]+'/'+ArStr[1]+'/'+ArStr[0]
            return value;
        }
    },
    dateFormatND(value) {
        if(value!=null){
            let year = value.substring(0,4);
            let month = value.substring(4,6);
            let day = value.substring(6,8);            
            value = day+'/'+month+'/'+year;
            return value;
        }
    },
    dateTimeFormat(value){
        if(value!=null){
            var etarr = value.split('T');
            var fecha = etarr[0].split('-').reverse().join('/');
            var hora = etarr[1].substring(0,8);
            return fecha +' '+ hora;
        }
    },    
    moneyFormat(value, showcurr) {
        if(value!=null){
            value = Number(value);
            var currency = showcurr == false ? '' : '$ ';
            return currency+(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
    },
    age(value) {
        const anio = parseInt(value.substring(0, 4), 10);
        const mes = parseInt(value.substring(4, 6), 10) - 1;
        const dia = parseInt(value.substring(6, 8), 10);
        const nacimiento = new Date(anio, mes, dia);
        const hoy = new Date();
        let edad = hoy.getFullYear() - nacimiento.getFullYear();
        const mesActual = hoy.getMonth();
        const diaActual = hoy.getDate();
        if (mesActual < mes || (mesActual === mes && diaActual < dia)) {
            edad--;
        }
        return edad;
    },
    monthFromDate(value){
        if(value!=null){
            var d = new Date();
            d.setMonth(d.getMonth() - value);
            return d.toLocaleDateString('en-GB').split('/').reverse().join('');
        }
    },
    dateValueFormat(value){
        if(value!=null){
            return value.toLocaleDateString('en-GB').split('/').reverse().join('');
        }
    },
    dateTimeValueFormat(value){
        if(value!=null){
            var etarr = value.split('T');
            var fecha = etarr[0].replaceAll('-','');
            var hora = etarr[1].substring(0,8).split(':').join('');
            return fecha + hora;
        }
    },
    formatDateTime(value) {
        if (!value || value.length !== 14) return '';
        const y = value.substring(0, 4);
        const m = value.substring(4, 6);
        const d = value.substring(6, 8);
        const h = value.substring(8, 10);
        const mi = value.substring(10, 12);
        const s = value.substring(12, 14);
        return `${d}/${m}/${y} ${h}:${mi}:${s}`;
    },
    getActivityIcon(value){
        let icon = "lni lni-circle-plus";
        switch(value){            
            case "Tareas":
                icon = "lni lni-inbox";
                break;
            case "Llamadas Telefónicas": 
                icon = "lni lni-phone";
                break;
            case "e-Mails":
                icon = "lni lni-envelope";
                break;
            case "Visitas":
                icon = "lni lni-home";
                break;
            case "SMS":
                icon = "lni lni-mobile";
                break;
            case "Redes Sociales": 
                icon = "lni lni-network";
                break;
            case "Cartas":
                icon = "lni lni-home";
                break;
            case "Chats":
                icon = "lni lni-comments";
                break;
        }
        return icon;
    }
}
app.config.globalProperties.$notify = {
    //type: success, error, warning, info
    handleMsj(type, msj){
        if(type=='success'){
            notify({
                message: msj,
                width: 350,
                shading: true,
                position: {
                    my: 'center center',
                    at: 'center center',
                },
                closeOnClick: true,            
            }, type, 4000);
        }else if(type=='error'){
            app.config.globalProperties.$toast.error(msj);
        }else if(type=='warning'){
            app.config.globalProperties.$toast.warning(msj);
        }else if(type=='info'){
            app.config.globalProperties.$toast.info(msj);
        }
    },
    handleError(error) {
        var message = '';
        if(error.response.status === 401){
            message = 'Su sesión ha caducado.';
            setTimeout(function(){
                localStorage.clear();
                location.reload();   
            }, 3200);  
            app.config.globalProperties.$toast.waning(message);          
        }else if(error.response.status === 404){
            return false;
        }else if(error.response.status === 400){
            message = "Algo salió mal. Intentá de nuevo en unos minutos.";
            app.config.globalProperties.$toast.warning(message);
        }else{
            message = error.message;
            app.config.globalProperties.$toast.error(message);
        }                
    }
}
